import { render } from "./InterfaceSettingsPage.vue?vue&type=template&id=622300d4&ts=true"
import script from "./InterfaceSettingsPage.vue?vue&type=script&lang=ts"
export * from "./InterfaceSettingsPage.vue?vue&type=script&lang=ts"

import "./InterfaceSettingsPage.vue?vue&type=style&index=0&id=622300d4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__